var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatPrivately(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_1781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72363 0.375C8.82296 0.375 10.4883 1.96417 10.4854 3.8623V5.42676H12.2744C13.0428 5.42691 13.6249 6.00615 13.625 6.66309V14.3887C13.6249 15.0456 13.0428 15.6248 12.2744 15.625H1.72559C0.957197 15.6248 0.375094 15.0456 0.375 14.3887V6.66309C0.375128 6.00615 0.95722 5.42691 1.72559 5.42676H2.96191V3.8623C2.96209 1.96344 4.62514 0.37518 6.72363 0.375Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73252 9.03295C6.39324 9.11474 6.11696 9.37828 6.03214 9.69635C5.92066 10.1144 6.10969 10.4983 6.43686 10.7074C6.47564 10.7323 6.49987 10.771 6.49987 10.8141V12.0705C6.49987 12.1432 6.56288 12.2 6.63801 12.2H7.3602C7.43775 12.2 7.49834 12.1409 7.49834 12.0705V10.8141C7.49834 10.771 7.52258 10.7323 7.56135 10.7074C7.82551 10.5392 8 10.2575 8 9.93717C8 9.33739 7.39898 8.86937 6.73252 9.03295Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5.4C3 5.17909 3.17909 5 3.4 5H10.6C10.8209 5 11 5.17909 11 5.4C11 5.62091 10.8209 5.8 10.6 5.8H3.4C3.17909 5.8 3 5.62091 3 5.4Z",
    fill: "black",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_1781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPrivately);
export default __webpack_public_path__ + "static/media/chatPrivately.00666f28cf3b774fe4ef655a6c9ddc85.svg";
export { ForwardRef as ReactComponent };